/*
 * Copyright (c) Dito Technologies
 */

import React from 'react';
import ReactDOM from 'react-dom';
import App from 'ui/App';
import reportWebVitals from './reportWebVitals';
import "index.scss"
import {initializeApp} from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyBnsV0NJFmGN0lD6XuCgnxK6wPLlueaxkI",
    authDomain: "ditotechnologies-music.firebaseapp.com",
    projectId: "ditotechnologies-music",
    storageBucket: "ditotechnologies-music.appspot.com",
    messagingSenderId: "490599662599",
    appId: "1:490599662599:web:a898f1f21fa32d6d8896a2",
    measurementId: "G-3DD9HLG95N"
};

initializeApp(firebaseConfig);

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
